'use client';
import { objectKeys } from '@s7/utils';
import { unit } from '../../sizes/impl/units/units.js';

const sortBreakpoints = (breakpoints)=>{
    return objectKeys(breakpoints).map((name)=>({
            name,
            value: unit(breakpoints[name])
        })).sort((a, b)=>a.value - b.value);
};
const isSmallestBreakpoint = (breakpoints, breakpoint)=>{
    return breakpoints[0] && breakpoints[0].name === breakpoint;
};
const getPreviousBreakpoint = (breakpoints, breakpoint)=>{
    const index = breakpoints.findIndex((b)=>b.name === breakpoint);
    if (index !== -1 && breakpoints[index - 1]) {
        return breakpoints[index - 1];
    }
    return null;
};
const getNextBreakpoint = (breakpoints, breakpoint)=>{
    const index = breakpoints.findIndex((b)=>b.name === breakpoint);
    if (index !== -1 && breakpoints[index + 1]) {
        return breakpoints[index + 1];
    }
    return null;
};

export { getNextBreakpoint, getPreviousBreakpoint, isSmallestBreakpoint, sortBreakpoints };
//# sourceMappingURL=breakpoints.js.map
